import { render, staticRenderFns } from "./Experiencia.vue?vue&type=template&id=47d1dc74&"
import script from "./Experiencia.vue?vue&type=script&lang=js&"
export * from "./Experiencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports